import connexion from './connexion';
import inscription from './inscription';
import franceConnect from './franceConnect';

export default {
	connexion,
	inscription,
	franceConnect
};
